import styled, { keyframes } from 'styled-components';

export const FullScreenLoader = () => {
  return (
    <LoaderWrapper>
      <img
        src="/favicon-light.svg"
        style={{ width: '10%', minWidth: '80px', maxWidth: '145px' }}
        alt="logo"
      />
    </LoaderWrapper>
  );
};

const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #000046; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    224deg,
    #8117a7 0%,
    #1d6ab9 49.48%,
    #82e580 100%
  );
  background: linear-gradient(224deg, #8117a7 0%, #1d6ab9 49.48%, #82e580 100%);
  background-size: 300% 300%;
  animation: ${gradientAnimation} 5s ease infinite;
`;
